import { BaseResource } from './base';
import type {
  Collaborator,
  ListCollaboratorsParams,
  UpdateCollaboratorDto,
  UpdateCollaboratorStatusDto,
  UpdateCollaboratorRoleDto,
  ActivityQueryParams,
  StatsQueryParams,
  CollaboratorStats,
  ActivityItem,
} from '@gymspace/shared';
import { RequestOptions, PaginatedResponseDto } from '../types';

export class CollaboratorsResource extends BaseResource {
  private basePath = 'collaborators';

  async list(
    params?: ListCollaboratorsParams,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<Collaborator>> {
    return this.paginate<Collaborator>(this.basePath, params, options);
  }

  async get(id: string, options?: RequestOptions): Promise<Collaborator> {
    return this.client.get<Collaborator>(`${this.basePath}/${id}`, undefined, options);
  }

  async update(
    id: string,
    data: UpdateCollaboratorDto,
    options?: RequestOptions,
  ): Promise<Collaborator> {
    return this.client.patch<Collaborator>(`${this.basePath}/${id}`, data, options);
  }

  async updateRole(
    id: string,
    data: UpdateCollaboratorRoleDto,
    options?: RequestOptions,
  ): Promise<Collaborator> {
    return this.client.patch<Collaborator>(`${this.basePath}/${id}/role`, data, options);
  }

  async updateStatus(
    id: string,
    data: UpdateCollaboratorStatusDto,
    options?: RequestOptions,
  ): Promise<Collaborator> {
    return this.client.patch<Collaborator>(`${this.basePath}/${id}/status`, data, options);
  }

  async getActivity(
    id: string,
    params?: ActivityQueryParams,
    options?: RequestOptions,
  ): Promise<ActivityItem[]> {
    return this.client.get<ActivityItem[]>(`${this.basePath}/${id}/activity`, params, options);
  }

  async getStats(
    id: string,
    params?: StatsQueryParams,
    options?: RequestOptions,
  ): Promise<CollaboratorStats> {
    return this.client.get<CollaboratorStats>(`${this.basePath}/${id}/stats`, params, options);
  }
}
